<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />

  <div
    v-else-if="page === 'binding'"
    class="page"
  >
    <div class="mt2 mb4 fs5 fw4 fc--primary">
      {{ clinic[composable.member.info.clinic].fullname }}
    </div>
    <div class="row--central ph6 mt4 mh2">
      <img
        class="image--circle image--size-x-3"
        :src="composable.member.info.linePictureUrl"
        @error="$event.target.src = clinic.urls.substitute"
      >
      <div class="column--central">
        <font-awesome-icon
          :icon="['fas', 'angle-double-right']"
          class="mh8"
        />
      </div>
      <img
        class="image--circle image--size-x-3"
        :src="clinic.urls.logo"
      >
    </div>

    <div class="page__text mv4">
      <p>您可以完成下列個人身份資訊填寫，</p>
      <p>以進行會員驗證。</p>
    </div>

    <div class="page__form">
      <input
        type="text"
        v-model="form.twid"
        placeholder="身份證號碼"
      >
      <input
        type="text"
        v-model="form.birthdate"
        placeholder="西元生日 共八碼"
      >
      <input
        type="text"
        v-model="form.mobile"
        placeholder="手機號碼"
      >
      <div class="page__input--with-checkbox mt1">
        <input
          type="checkbox"
          v-model="form.lineTOS"
        ><label
          for="a1"
        >本人同意連結LINE帳號方便查詢與預約。</label>
      </div>
      <div class="page__input--with-checkbox mt1">
        <input
          type="checkbox"
          v-model="form.internetAndPrivacyTos"
        ><label
          for="a2"
        >本人同意<a
          href="#"
          @click.prevent="page = 'internetTos'"
        >網路服務約定條款</a>與<a
          href="#"
          @click.prevent="page = 'privacyTos'"
        >隱私權及資訊安全政策。</a></label>
      </div>
      <div
        class="label label--primary"
        @click="showBindingConfirm"
      >
        送出
      </div>
    </div>

    <div class="page__text align--left fs1 mt3">
      *請輸入欄位後點選送出進行資訊綁定
    </div>
  </div>

  <InternetTos
    v-else-if="page === 'internetTos'"
    :line-picture-url="composable.member.info.linePictureUrl"
    @close="page = 'binding'"
  />

  <PrivacyTos
    v-else-if="page === 'privacyTos'"
    :line-picture-url="composable.member.info.linePictureUrl"
    @close="page = 'binding'"
  />

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
    @done="liff.closeWindow"
    @confirm="verifyMemberShip"
  />
</template>

<script>
import {
  ref, onMounted, reactive,
} from 'vue';
import { useRoute } from 'vue-router';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import composable from '@/composable/index';
import InternetTos from './pages/InternetTos.vue';
import PrivacyTos from './pages/PrivacyTos.vue';

export default {
  components: { InternetTos, PrivacyTos },
  setup() {
    const route = useRoute();
    const page = ref('initialization');
    const form = reactive({
      twid: null,
      birthdate: null,
      mobile: null,
      internetAndPrivacyTos: false,
      lineTOS: false,
    });

    onMounted(async () => {
      try {
        composable.loading.show('資料載入中');

        const { clinic } = route.params;
        if (clinic === 'heart') {
          await composable.member.initialize({
            liffId: '1656042583-2ZEZzdn7',
            clinic: '金安心',
          });
        } else if (clinic === 'beauty') {
          await composable.member.initialize({
            liffId: '1656042583-1pMaxLK7',
            clinic: '金禾美',
          });
        }
        page.value = 'binding';
      } catch (error) {
        page.value = 'death';
        composable.death.show(error);
      } finally {
        composable.loading.close();
      }
    });

    async function showBindingConfirm() {
      try {
        spiderman.form.verify(form);
        form.birthdate = spiderman.moment(form.birthdate).format('YYYY-MM-DD');

        composable.modal.confirm(
          `請再次確認您的就診資料是否正確，經綁定後將無法再自行變更。\n
          身分證:${form.twid}\n
          生日:${form.birthdate}\n
          手機號碼:${form.mobile}`,
        );
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    async function verifyMemberShip() {
      try {
        if (!form.lineTOS || !form.internetAndPrivacyTos) { throw Error('請同意我們的政策'); }

        spiderman.form.verify(form);
        form.birthdate = spiderman.moment(form.birthdate).format('YYYY-MM-DD');

        composable.loading.show('會員綁定中，請稍候');

        await api.membership.verify(composable.member, form);

        composable.modal.done(
          '您已完成帳號連結，接下來可以更方便的使用線上功能服務。',
        );
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    return {
      liff: spiderman.liff,
      composable,
      page,
      clinic: spiderman.clinic,
      form,
      showBindingConfirm,
      verifyMemberShip,
    };
  },
};
</script>
